import { Component } from '@angular/core';
import { ComponentInstance } from 'src/app/models/enum';
import { TimeoutContentComponent } from '../order-complete/timeout-content/timeout-content.component';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  imports: [TimeoutContentComponent],
})
export class TimeoutComponent {
  public get ComponentInstance() {
    return ComponentInstance;
  }
}
